window.addEventListener("load", function(){
  let rcRadioInputSub = document.getElementById("rc-radio1")
  let rcRadioInputSingle = document.getElementById("rc-radio2")
  let sezzleDisplay = document.getElementById("sezzle-container-custom")
  let priceEl = document.getElementsByClassName("amount")[0]
  let truePrice = priceEl.innerText
  let rcPrice = document.getElementsByClassName("rc-radio__price")[0].innerText.toString().split(" ")[1]
  
  //console.log(truePrice)
  //console.log(rcPrice)
  //console.log(rcRadioInput)
  //console.log(sezzleDisplay)
  
  if(rcRadioInputSub.checked){
    //console.log("CHECKED")
    changeFrequencyText()
    priceEl.innerText = rcPrice;
    
    
  } else {
    //console.log("Not checked")
    sezzleDisplay.style.display = "block";
    priceEl.innerText = truePrice
  }
  
  rcRadioInputSub.addEventListener("change", function(e){
    //console.log(e.target.checked)
    
    changeFrequencyText()
    if(e.target.checked){
      sezzleDisplay.style.display = "none";
      priceEl.innerText = rcPrice
      
      //console.log("CHECKED")
    } else {
      sezzleDisplay.style.display = "block";
      priceEl.innerText = truePrice
      
    }
    
  })

  rcRadioInputSingle.addEventListener("change", function(e){
    //console.log(e.target.checked)
    if(e.target.checked){
      sezzleDisplay.style.display = "block";
      priceEl.innerText = truePrice
    }
    
  })


function changeFrequencyText(){
  let frequencySelector = document.getElementsByClassName("rc-selling-plans-dropdown__select")[0]
  let rcLabel = document.getElementsByClassName("rc-selling-plans-dropdown__label")[0]
  let rcParent = document.getElementsByClassName("rc-selling-plans-dropdown")[0]
  let newSpan = document.createElement("span")
  rcLabel.classList.remove("visually-hidden")
  
  newSpan.classList.add("custom-recharge-select-arrow")  
  newSpan.innerHTML = `<svg class="custom-select-arrow" xmlns="http://www.w3.org/2000/svg" width="16" height="8" viewBox="0 0 16 8" fill="#FFFFFF">
  <path d="M8.00002 8C7.41668 8 6.83335 7.775 6.39168 7.33334L0.95835 1.9C0.716683 1.65833 0.716683 1.25834 0.95835 1.01667C1.20002 0.775002 1.60002 0.775002 1.84168 1.01667L7.27502 6.45C7.67502 6.85 8.32502 6.85 8.72502 6.45L14.1583 1.01667C14.4 0.775002 14.8 0.775002 15.0417 1.01667C15.2833 1.25834 15.2833 1.65833 15.0417 1.9L9.60835 7.33334C9.16668 7.775 8.58335 8 8.00002 8Z" fill=""/>
  </svg>`
  rcParent.appendChild(newSpan)
  //frequencySelector.outerHTML = `<select onfocus='this.size=25;' onblur='this.size=1;' onchange='this.size=1; this.blur();' id="sellingPlan6905653461152" class="rc-selling-plans-dropdown__select" name="rc_selling_plan" data-v-ad7b841c=""><option value="3213721845" data-v-ad7b841c="">Small Dog (Under 20lbs) Delivery Every 30 Days</option><option value="3213754613" data-v-ad7b841c="">Medium Dog (20-30lbs) Delivery Every 60 Days</option><option value="3213787381" data-v-ad7b841c="">Large Dog (Over 50lbs) Delivery Every 90 Days</option></select>` 
  frequencySelector.options[0].innerText = "Large Dog (Over 50lbs) Delivery Every 30 Days";
  frequencySelector.options[1].innerText = "Medium Dog (20-30lbs) Delivery Every 60 Days";
  frequencySelector.options[2].innerText = "Small Dog (Under 20lbs) Delivery Every 90 Days";
  
}
})

  /*
  let rechargeParent = document.getElementsByClassName("rc-selling-plans-dropdown")[0]
  let rechargeSpan = document.getElementsByClassName("rc-selling-plans-dropdown__label")[0]
  let rechargeSelect = document.getElementsByClassName("rc-selling-plans-dropdown__select")[0]
  console.log(rechargeSelect.outerHTML)
  
  //const parser = new DOMParser();
  //const doc3 = parser.parseFromString(parsedSelect, "text/html");
    //rechargeParent.innerHTML = `${rechargeSpan.outerHTML}<div class="custom-select" style="width:200px;"> <select id="" class="rc-selling-plans-dropdown__select" name="rc_selling_plan" data-v-ad7b841c=""><option value="0">Select One</option><option value="3213721845" data-v-ad7b841c="">Delivery every 30 Days</option><option value="3213754613" data-v-ad7b841c="">Delivery every 60 Days</option><option value="3213787381" data-v-ad7b841c="">Delivery every 90 Days</option></select></div>`
    //rechargeSelect.innerHTML = `<option value="0">Select One</option><option value="3213721845" data-v-ad7b841c="">Delivery every 30 Days</option><option value="3213754613" data-v-ad7b841c="">Delivery every 60 Days</option><option value="3213787381" data-v-ad7b841c="">Delivery every 90 Days</option>`
    //rechargeSelect.removeAttribute = "id"

  //console.log(rechargeSelect.selectedIndex = 1)
  rechargeSelect.value='3213787381';
  console.log(rechargeSelect.value)
  rechargeSelect.options[2].selected = true
  // DROPDOWN SELECT
*/
  


